export default {
	methods:
    {				
	}, 
    
}